module.exports = ".loading { opacity:0.5; }"